// Ordered list of Georgian cities the user can pick as their delivery city.
// `value` is the canonical stored form (Latin/English, used in the DB).
// `label` is the display form (Georgian) shown in dropdowns.
// If you need to add / rename / remove a city, edit this file — both the
// registration form and the address management page read from it.

const georgianCities = [
  { value: "Tbilisi",        label: "თბილისი" },
  { value: "Abasha",         label: "აბაშა" },
  { value: "Ambrolauri",     label: "ამბროლაური" },
  { value: "Akhalkalaki",    label: "ახალქალაქი" },
  { value: "Akhaltsikhe",    label: "ახალციხე" },
  { value: "Akhmeta",        label: "ახმეტა" },
  { value: "Batumi",         label: "ბათუმი" },
  { value: "Baghdati",       label: "ბაღდათი" },
  { value: "Bolnisi",        label: "ბოლნისი" },
  { value: "Borjomi",        label: "ბორჯომი" },
  { value: "Gardabani",      label: "გარდაბანი" },
  { value: "Gori",           label: "გორი" },
  { value: "Gurjaani",       label: "გურჯაანი" },
  { value: "Dedoplistskaro", label: "დედოფლისწყარო" },
  { value: "Dmanisi",        label: "დმანისი" },
  { value: "Dusheti",        label: "დუშეთი" },
  { value: "Vale",           label: "ვალე" },
  { value: "Vani",           label: "ვანი" },
  { value: "Zestaponi",      label: "ზესტაფონი" },
  { value: "Zugdidi",        label: "ზუგდიდი" },
  { value: "Tetritskaro",    label: "თეთრიწყარო" },
  { value: "Telavi",         label: "თელავი" },
  { value: "Terjola",        label: "თერჯოლა" },
  { value: "Kaspi",          label: "კასპი" },
  { value: "Lagodekhi",      label: "ლაგოდეხი" },
  { value: "Lanchkhuti",     label: "ლანჩხუთი" },
  { value: "Marneuli",       label: "მარნეული" },
  { value: "Martvili",       label: "მარტვილი" },
  { value: "Mtskheta",       label: "მცხეთა" },
  { value: "Ninotsminda",    label: "ნინოწმინდა" },
  { value: "Ozurgeti",       label: "ოზურგეთი" },
  { value: "Oni",            label: "ონი" },
  { value: "Rustavi",        label: "რუსთავი" },
  { value: "Sagarejo",       label: "საგარეჯო" },
  { value: "Samtredia",      label: "სამტრედია" },
  { value: "Sachkhere",      label: "საჩხერე" },
  { value: "Senaki",         label: "სენაკი" },
  { value: "Sighnaghi",      label: "სიღნაღი" },
  { value: "Tkibuli",        label: "ტყიბული" },
  { value: "Poti",           label: "ფოთი" },
  { value: "Kareli",         label: "ქარელი" },
  { value: "Kobuleti",       label: "ქობულეთი" },
  { value: "Kutaisi",        label: "ქუთაისი" },
  { value: "Kvareli",        label: "ყვარელი" },
  { value: "Tsageri",        label: "ცაგერი" },
  { value: "Tsalenjikha",    label: "წალენჯიხა" },
  { value: "Tsalka",         label: "წალკა" },
  { value: "Tsnori",         label: "წნორი" },
  { value: "Tskaltubo",      label: "წყალტუბო" },
  { value: "Chiatura",       label: "ჭიათურა" },
  { value: "Khashuri",       label: "ხაშური" },
  { value: "Khobi",          label: "ხობი" },
  { value: "Khoni",          label: "ხონი" },
  { value: "Jvari",          label: "ჯვარი" },
  // Highland additions — billed at Highland rates for home delivery.
  { value: "Khulo",          label: "ხულო" },
  { value: "Shuakhevi",      label: "შუახევი" },
  { value: "Keda",           label: "ქედა" },
  { value: "Stepantsminda",  label: "სტეფანწმინდა" },
  { value: "Mestia",         label: "მესტია" },
  { value: "Lentekhi",       label: "ლენტეხი" },
];

export default georgianCities;
